import React, { useState } from "react";
import FiltersList from "../FiltersList";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
// types
import { FiltersProps } from "./types";
import ReportsColumnModal from "view/components/Modals/Reports/ReportsColumnModal";
import { IfetchReports } from "store/reports/initialState";

export const Filters: React.FC<FiltersProps> = ({
  columnOrder,
  setColumnOrder,
  columns,
  columnVisibility,
  setColumnVisibility,
  setColumnsConfig,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCloseDiv, setIsCloseDiv] = useState(true);
  const { data } = useSelector<RootState, IfetchReports>(
    (state) => state?.allReports
  );
  // Handlers
  const handleToggleDropdown = () => {
    setIsCloseDiv((prevState) => !prevState);
  };

  // Initializing event listener
  return (
    <>
      <div className="flex flex-col items-start justify-start w-full gap-2">
        <FiltersList isCloseDiv={isCloseDiv} />
      </div>
    </>
  );
};
